import * as React from "react";
import { Stack, Typography, Paper } from "@mui/material";

export default function SettingsPage() {
    return (
        <Stack spacing={2}>
            <Typography variant="h5" sx={{ fontWeight: 1000 }}>Settings</Typography>
            <Paper variant="outlined" sx={{ p: 2.5, borderRadius: 3 }}>
                <Typography color="text.secondary">Coming next: business settings, admins, plan</Typography>
            </Paper>
        </Stack>
    );
}
